<ng-template #desc i18n>malejąco</ng-template>
<ng-template #asc i18n>rosnąco</ng-template>
<div ngbDropdown>
  <button
    ndt-tertiary-button
    ngbDropdownToggle
    type="button"
    class="p-0 text-secondary-500 hover:text-opacity-75"
    [attr.aria-controls]="id"
  >
    <span class="font-semibold" i18n>Sortowanie:</span>
    <ng-template #choose i18n>Wybierz</ng-template>
    <ng-container *ngIf="currentSorting; else choose">
      <span class="inline-flex items-center">
        {{ currentSorting.label }}
        <ng-container *ngIf="currentSorting.direction === 'asc'" [ngTemplateOutlet]="asc"></ng-container>
        <ng-container *ngIf="currentSorting.direction === 'desc'" [ngTemplateOutlet]="desc"></ng-container>
      </span>
    </ng-container>
  </button>
  <ul [id]="id" class="dropdown-menu" role="menu" ngbDropdownMenu>
    <li *ngFor="let option of options" role="menuitem">
      <button class="dropdown-item" type="button" ngbDropdownItem (click)="setSorting(option)">
        {{ option.label }}
        <ng-container *ngIf="option.direction === 'asc'" [ngTemplateOutlet]="asc"></ng-container>
        <ng-container *ngIf="option.direction === 'desc'" [ngTemplateOutlet]="desc"></ng-container>
      </button>
    </li>
  </ul>
</div>
